import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { deleteAccountExpensePolicyAsync, updateAccountExpensePolicyAsync, getAccountExpensePolicyByIdAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState, updateMasterExpensePolicyId,updateSorting } from './expensePolicySlice';
import { Link, useNavigate } from 'react-router-dom';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { setItemStatus, getValueFromResource} from '../../../common/timeLiveFunction';


const itemClass = 'ms-1 ms-lg-0';

const ExpensePolicyItem = (props: any) => {
    const { expensePolicyList, modelRef, t, onopenModal, oncloseModal, IsEdit, IsDelete } = props;
    const dispatch = useAppDispatch();
    const { isLoading ,sortOrder, sortColumn,pageSize } = useAppSelector((state) => state.expensePolicy);
    const navigate = useNavigate();

    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };
    const onEditClick = (AccountExpensePolicyId: string) => {
        dispatch(getAccountExpensePolicyByIdAsync(AccountExpensePolicyId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {

            })
    }

    const onDeleteClick = (AccountExpensePolicyId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountExpensePolicyAsync(AccountExpensePolicyId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Expense policy deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsDisabledChange = (e: any, AccountExpensePolicy: any) => {
        const { checked } = e.target;
        const foundIndex = expensePolicyList.findIndex((item: any) => item.AccountExpensePolicyId === AccountExpensePolicy.AccountExpensePolicyId);
        if (foundIndex !== -1) {
            const foundItem = expensePolicyList[foundIndex];
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            const modifiedList = [...expensePolicyList.slice(0, foundIndex), updatedItem, ...expensePolicyList.slice(foundIndex + 1)];
            dispatch(updateAccountExpensePolicyAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("Expense policy Update Successfully", 'Success', "success", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
    }

    const navigateToExpensePolicyDetails = (obj: any) => {
        localStorage.setItem('objExpensePolicyItem', JSON.stringify(obj));
        // navigate('/expensepolicydetail', { state: { obj } });
        navigate(`/expensepolicydetail/${obj.AccountExpensePolicyId}`);
        dispatch(updateMasterExpensePolicyId(obj.AccountExpensePolicyId));
    };

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle " >
                        {IsDelete &&
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={expensePolicyList.every((item: any) => item.isSelected === 0) ? false :
                                            (expensePolicyList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        }
                         <th style={{width:'15%'}}>
                            {/* {t('Active / Inactive')} */}
                            {getValueFromResource('Active / Inactive',dispatch, t)}
                        {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{width:'50%'}}>
                            {/* {t('Expense Policy')} */}
                            {getValueFromResource('Expense Policy',dispatch, t)}
                        {sortColumn === 'ExpensePolicyName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ExpensePolicyName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ExpensePolicyName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ExpensePolicyName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ExpensePolicyName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{width:'15%'}}>
                            {/* {t('Description')} */}
                            {getValueFromResource('Description',dispatch, t)}
                        {sortColumn === 'ExpensePolicyDescription' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ExpensePolicyDescription") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ExpensePolicyDescription") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ExpensePolicyDescription") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ExpensePolicyDescription") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                                </th>
                        {/* {IsEdit &&
                            <th className='w-15'>{t('Active / Inactive')}</th>
                        } */}
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                  
                    {expensePolicyList.length > 0 && expensePolicyList.map((expensePolicyDetail: any, i: any) => (
                        <tr key={i}>
                            {IsDelete &&
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check "
                                            checked={expensePolicyDetail.isSelected == 0 ? false : true}
                                            onChange={(e) => { handleCheckboxChange(e, expensePolicyDetail.AccountExpensePolicyId) }}

                                        />
                                    </div>
                                </td>
                            }
                            <td>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(expensePolicyDetail.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                    {expensePolicyDetail.IsDisabled === 'No' ? "Active" : "InActive"}
                                </span>
                            </td>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor ' onClick={IsEdit ? () => onEditClick(expensePolicyDetail.AccountExpensePolicyId) : undefined}>
                                <span className="   d-block "
                                >{expensePolicyDetail.ExpensePolicyName}</span>
                            </td>
                            <td>
                                {expensePolicyDetail.ExpensePolicyDescription}
                            </td>
                            {/* {IsEdit &&
                                <td className='text-center'>

                                        <div className="form-check form-switch form-check-custom">
                                            <input
                                                type="checkbox"
                                                className="form-check-input custom-padding-right h-15px w-30px"
                                                id="IsDisabled"
                                                checked={expensePolicyDetail.IsDisabled === 'Yes' ? true : false}
                                                onChange={(e) => { handleIsDisabledChange(e, expensePolicyDetail) }}
                                            /> 
                                           </div>

                                </td>
                            } */}
                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                        {IsEdit &&
                                            <>
                                                <div className='menu-hover-bg-sec'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => {
                                                            dispatch(getAccountExpensePolicyByIdAsync(expensePolicyDetail.AccountExpensePolicyId))
                                                                .unwrap()
                                                                .then((originalPromiseResult) => {
                                                                    onopenModal();
                                                                })
                                                                .catch((rejectedValueOrSerializedError) => {
                                                                })
                                                        }}
                                                    >
                                                        <span className="menu-icon custom-menu">
                                                            <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title custom-menu-fontsize">
                                                            {/* {`${t('Edit')}`} */}
                                                            {getValueFromResource('Edit',dispatch, t)}
                                                            </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </>
                                        }
                                        {IsEdit && <>
                                            <div className='menu-hover-bg-pri'>
                                                <Dropdown.Item
                                                    className="menu-item me-lg-0"
                                                    onClick={() => {
                                                        navigateToExpensePolicyDetails({
                                                            "AccountExpensePolicyId": expensePolicyDetail.AccountExpensePolicyId
                                                        });
                                                    }}
                                                >
                                                    <span className="menu-icon custom-menu">
                                                        <i className="bi bi-receipt fs-6">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                    <span className="menu-title custom-menu-fontsize">
                                                        {/* {`${t('Details')}`} */}
                                                        {getValueFromResource('Details',dispatch, t)}
                                                        </span>
                                                </Dropdown.Item>
                                               
                                            </div>
                                        </>}
                                        {IsDelete && IsEdit &&
                                            <div className='separator mb-1 mt-1 opacity-75 '></div>
                                        }
                                        {IsDelete &&
                                            <>
                                                <div className='menu-hover-bg-danger'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => { onDeleteClick(expensePolicyDetail.AccountExpensePolicyId) }}>
                                                        <span className="menu-icon  custom-menu">
                                                            <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                            {/* {`${t('Delete')}`} */}
                                                            {getValueFromResource('Delete',dispatch, t)}
                                                            </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </>
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>

                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {expensePolicyList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found',dispatch, t)}
                                    </p>
                            </div>
                        }
        </>
    )

}

export default ExpensePolicyItem